<template>
  <div style="width: 100%;height: 100%;">
    <Row v-if="openFlag" style="width: 100%;height: 6%;background-color: rgb(22,155,213);">
      <Col style="height: 100%;" :xs="12" :sm="12" :md="12" :lg="12">
        <div style="height: 100%;float: left;color: white;font-size: 20px;align-items: center;justify-content: center;display:flex;padding-left: 20px;">
          {{channelName}}</div>
      </Col>
      <Col style="height: 100%;" :xs="12" :sm="12" :md="12" :lg="12">
        <div style="height: 100%;float: right;color: white;font-size: 20px;align-items: center;justify-content: center;display:flex;padding-right: 20px;"><img style="width: 30px;height: auto" @click= "endSession" title="结束会话" src="@/assets/image/online/whitePower.png"/></div>
      </Col>
    </Row>
    <Row class="rowOne" :style="screenHeight">
      <Col span="24" class="taleBox" id="taleBox" style="width: 100%;height: 100%;overflow-y: auto;">
        <div style="width: 100%;">
          <div style="text-align: center;color: #666;" v-if="onLineMsgList.length < totalSize">
            <span style="cursor: pointer;color: blue;" @click="moreClick">查看更多消息</span>
          </div>
          <div class="cusandstaff" v-for= "(item, index) in onLineMsgList" :key="index">
            <!-- tip有值显示tip -->
            <div v-if="item.tip" class="msgTipDiv">
              <span class="msgTip">{{timeFormat(item.createTime) + "  "+ item.tip}}</span>
            </div>
            <div v-else>
              <div v-if="item.agentNumber === currentCustomer || item.agentNumber.indexOf('web_') != -1" class="online_staff" >
                <div class="online_staff_info">
                  <div  class="online_staff_infodetail" >
                    <p  class="online_staff_info">{{timeFormat(item.createTime)}}</p>
                  </div>
                  <div class="online_staff_dialofont">
                    <Msg :msgType="item.msgType" v-model="item.content"/>
                  </div>
                </div>
              </div>
              <div v-else class="online_cus">
                <div class="online_cus_infoimg">
                  <img style="border-radius: 50%;height: auto;width: 20px;" :src="item.headImg ? (item.headImg.indexOf('http') === 0 ? item.headImg : (baseImgURL + item.headImg)) : require('@/assets/image/customerService.png')"/>
                </div>
                <div  class="online_cus_info">
                  <div  class="online_cus_infodetail">
                    <p  class="online_cus_info">{{item.agentNumber + "&nbsp;&nbsp;&nbsp;&nbsp;"+ timeFormat(item.createTime)}}</p>
                  </div>
                  <div class="online_cus_dialofont">
                    <Msg :msgType="item.msgType" v-model="item.content"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <Row v-if="isOpen" style="width: 100%;height: 8%;background-color: rgb(221,221,221);">
      <Col style="height: 98%;align-items: center;justify-content: center;display: flex;" :xs="8" :sm="6" :md="4" :lg="2">
        <div class="inputbox-iconlist">
          <Poptip placement="top" transfer class="inputbox-button">
            <img src="@/assets/image/online/Emoticon.png"/>
            <div slot="content" >
              <div v-for="(item, index) in emojiList" :key="index">
                <img :src="emotion.emoji" v-for="(emotion,key) in item" :key="key" :title="emotion.descr" @click="clickHandler(emotion)"/>
              </div>
            </div>
          </Poptip>
          <div class="inputbox-button">
            <Upload :action="baseUploadUrl" :show-upload-list="false" accept=".mp4" :on-success="(res,file)=>onSuccess(res)" :before-upload="beforeUpload" :on-error="uploadFail">
              <img src="@/assets/image/online/foldericon.png"/>
            </Upload>

          </div>
          <div class="inputbox-button">
            <Upload :action="baseUploadUrl" :show-upload-list="false" accept="image/gif, image/jpeg, image/jpg, image/png" :format="['jpg','jpeg','png','gif']" :on-format-error="handleFormatError" :on-success="(res,file)=>onSuccess(res)" :before-upload="beforeUpload" :on-error="uploadFail">
              <img src="@/assets/image/online/picicon.png"/>
            </Upload>
          </div>
        </div>
      </Col>
      <Col style="height: 98%;align-items: center;justify-content: center;display: flex;" :xs="10" :sm="12" :md="16" :lg="20">
        <div class="edittext" @blur="blurTo" contenteditable ref="editDiv" v-html="inputContent"  style="height: auto;max-height: 100%;min-height: 70%;width: 100%;background-color: white;margin-top: 0px">

        </div>
      </Col>
      <Col style="height: 98%;align-items: center;justify-content: center;display: flex;" :xs="6" :sm="6" :md="4" :lg="2">
        <Button type="primary" @mousedown.native="prentFocus($event)" class="submit_btn" @click="keypressEvent">发送</Button>
      </Col>
    </Row>
    <Row v-else style="width: 100%;height: 8%;background-color: rgb(221,221,221);">
      <Col style="height: 98%;align-items: center;justify-content: center;display: flex;">
        <p style="font-size: 16px">会话已结束，请<a @click="openUrl">重新咨询</a></p>
      </Col>
    </Row>
    <div hidden id="forWebDiv" @click="disconnect"></div>
  </div>

</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js';
  import Msg from '@/components/OnlineService/Msg.vue';
  import Vue from "vue";
    export default {
        name: "ExternalWebPage",
        mixins:[publicFunClass],
        components:{
          Msg,
        },
      data() {
        return {
          screenHeight:{height:''},
          channelName:'在线客服',
          openId:'',
          isOpen:true,
          totalSize: 0,
          baseUploadUrl: this.baseURL+"common/upload.json?type=wx&companyNo="+localStorage.getItem("companyId"),
          onLineMsgList:[], //消息列表
          agentInfo: JSON.parse(localStorage.getItem("agentInfo")), //座席信息
          currentCustomer: '',  //当前客户
          inputContent: '', //输入的内容
          wxName: '', //微信号
          sessionId: '',
          sessionChannel:'-7', //渠道类型
          emojiList: require('@/assets/emotion.json'),
          value:'',
          msgType: 'text',
          msgSource: '',
          onlineInfo: null,
          headImg: '',
          chatClient: '',
          topic: '',
          chatSubscribeId: null,
          MQTT_SERVICE:'',
          MQTT_USERNAME:'admin',
          MQTT_PASSWORD:'YunEasy_eos',
          urlIp:'',
          token:'',
          companyCode:'',
          browseUrl:'',
          navId:'',
          sessionStatus: "0",
          type:'',
          sessionType: "0",
          isNewOpen:'',
          openFlag:true,
          mqAddr:'',
        }
      },
      methods:{
        blurTo(){
          window.scrollTo(0,0)
        },
        //阻止移动端点击发送按钮输入框失去焦点的问题
        prentFocus:function(event){
          event.preventDefault();
        },
        //MQ建立连接
        connect: function () {
          if (!this.chatClient.connected) {
            this.chatClient = this.Stomp.client(this.MQTT_SERVICE);
          }
          const headers = {
            login: this.MQTT_USERNAME,
            passcode: this.MQTT_PASSWORD
          };
          this.chatClient.connect(headers, this.onConnected, this.onFailed);
        },
        //消息订阅失败
        onFailed: function (frame) {
          console.log("连接失败: " + frame);
          this.connect();
        },
        //接收消息处理
        responseCallback: function (frame) {
          let body = JSON.parse(frame.body);

          this.sessionStatus = body.sessionStatus;
          this.type = body.type;
          this.sessionType = body.sessionType;
          this.sessionId = body.sessionId;
          this.msgSource = body.msgSource;
          if(body.agentNumber === body.openId){
            return;
          }

          body.createTime = body.createTime.replace(/-/g,'/');
          this.createTime = body.createTime;
          if(body.type === "pushPointChatMessage"){  //是在线客服，才进行处理
            this.onLineMsgList.push(body);
          }else if(body.type === "pushPublicChatMessage"){   //公共消息处理，如排队中的客户，浏览中的客户，需要所有员工都收到的
            this.onLineMsgList.push(body);
          }else if(body.type === "pushDeleteChatMessage"){ //删除所有座席都能看到的客户，比如排队中的客户
            this.onLineMsgList.push(body);
            this.isOpen = false;
            this.request(true);
            this.sessionStatus = "0";
            this.sessionType = "0";
            this.sessionId = "";
            this.msgSource = "";
            return;
          }else if(body.type === "pushConfChatMessage"){ //多方会话收到的消息
                this.onLineMsgList.push(body);
          }
        },
        //订阅频道
        onConnected: function (frame) {
          this.isOpen = true;
          let msg = {
            "msgType": this.msgType,
            "content": "",
            "openId": this.openId,
            "value": this.value,
            "tip":"访客请求接入会话",
            "agentNumber": this.currentCustomer,
            "sessionId":  this.sessionId,
            "wxName": this.wxName,
            "sessionChannel": this.sessionChannel,
            "msgSource": '',
            "createTime": this.getCurrentTime(),
            "type":'pushPublicChatMessage',
            "msgMark": this.getTime(),
            "headImg": "",
            "sessionType": '0',
            "sessionStatus":'0'
          }
          let that = this;
          setTimeout(function () {
            console.log("在线客服订阅: " + frame);
            if (!that.chatClient.connected) {
              that.connect();
              return false;
            }
            // 测试
            // that.topic = "/queue/6666";
            let object = that.chatClient.subscribe(that.topic, that.responseCallback, {'auto-delete':true,'x-message-ttl':30000});
            that.chatSubscribeId = object.id;
            that.sendMsg(msg);
          }, 1000);
        },
        disconnect: function(){
          //关闭连接
          if (this.chatSubscribeId) {
            this.chatClient.unsubscribe(this.chatSubscribeId);
            this.chatClient.disconnect();
            this.chatSubscribeId = "";
          }
        },
        // 向后端发送数据
        sendMsg: function(msg){
          if (this.chatClient.connected) {
            this.chatClient.send("/queue/mpccChatReceiver", {
              "content-type": "text/plain",
              "x-message-ttl": "30000"
            }, JSON.stringify(msg));
          }else{
            console.error("MQ连接失败，不能发送消息");
            this.$Message.error("连接失败，请重新登录");
          }
        },
        // 发送消息
        sendMessage(content){
          content = content.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
            .replace(/<\/?.+?\/?>/g,''); //替换html标签
          if(!content){
            this.$Message.error("请输入发送内容");
            return false;
          }
          let msg = {
            "msgType": this.msgType,
            "content": content,
            "openId": this.openId,
            "value": this.value,
            "tip":"",
            "agentNumber": this.currentCustomer,
            "sessionId":  this.sessionId,
            "wxName": this.wxName,
            "sessionChannel": this.sessionChannel,
            "msgSource": this.msgSource,
            "createTime": this.getCurrentTime(),
            "type":this.type,
            "msgMark": this.getTime(),
            "headImg": "",
            "sessionType": this.sessionType,
            "sessionStatus":this.sessionStatus
          }
          this.sendMsg(msg);
          this.onLineMsgList.push(msg);
          return false;
        },
        getCurrentTime: function(){
          let time = new Date();
          let newTime = this.formatDate(time,"yyyy-MM-dd hh:mm:ss");
          if(this.isIos()){
            newTime = newTime.replace(/-/g,'/');
          }
          return newTime;
        },
        getTime: function(){
          let time = new Date();
          return time.getTime();
        },
        //重新发起会话
        openUrl:function(){
          this.doCheck();
          // this.initConfig();
        },
        // 结束会话
        endSession: function(){
          let that = this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否结束会话",
            onOk: () => {
              that.isOpen = false;
              that.request();
            }
          });
        },
        request: function(flag){
          let param = {
            "visitorName": this.value,
            "sessionId": this.sessionId,
            "companyCode": this.companyCode,
            "token": this.token,
            "journalType": "结束会话",
            "menuId":"null",
            "unionId":this.topic,
          }
          let that = this;
          this.$http.post("api/chatApi/doH5LogOut.json",param).then(function (res) {  //待处理客户查询
            let result=res.data.flag;
            if(result!="666"){
              return false;
            }
            if(!flag){
              that.$Message.success("结束成功");
            }
          })
          that.disconnect();
        },
        // 发送消息
        keypressEvent: function(event){
            let newHtml = this.$refs.editDiv.innerHTML;
            this.inputContent = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
              .replace(/<\/?.+?\/?>/g,''); //替换html标签
            if(!this.inputContent){
              this.$Message.error("请输入发送内容");
              return false;
            }
            event.preventDefault() // 阻止浏览器默认换行操作
            this.msgType = "text";
            this.sendMessage(this.inputContent);
            this.$refs.editDiv.innerHTML = "";
            this.inputContent = "";
        },
        // 表情点击
        clickHandler: function(item){
          this.inputContent = this.$refs.editDiv.innerHTML + "<font style='display:none'>"+item.chars+"</font><img src='"+item.emoji+"'/>";
          this.$refs.editDiv.innerHTML = this.inputContent;
        },
        //上传成功
        onSuccess(res) {
          if(res.flag != '666'){
            this.$Message.error(res.msg);
            return false;
          }
          this.sendMessage(res.obj.absolutePath);
        },
        //上传失败
        uploadFail(){
          this.$Message.error("上传失败");
        },
        beforeUpload (file) {
          if("image/jpeg"== file.type || "image/png"== file.type || "image/jpg"== file.type || "image/gif"== file.type){
            if(file.size > 10240*1000){
              this.$Message.error("图片"+file.name + "超出文件大小限制，上传文件不能超过10M。");
              return false;
            }
            this.msgType = "image";
          }else if("audio/mpeg" == file.type){
            if(file.size > 2048*1000){
              this.$Message.error("语音"+file.name + "超出文件大小限制，上传文件不能超过2M。");
              return false;
            }
            this.msgType = "voice";
          }else if("video/mp4" == file.type){
            if(file.size > 10240*1000){
              this.$Message.error("视频"+file.name + "超出文件大小限制，上传文件不能超过10M。");
              return false;
            }
            this.msgType = "video";
          }
        },
        handleFormatError(file){
          this.$Message.error(file.name + "文件格式错误，请上传JPEG/PNG/JPG/GIF格式图片。");
        },
        // 滑动到底部
        scrollToBottom: function () {
          this.$nextTick(() => {
            let container = this.$el.querySelector(".taleBox");
            container.scrollTop = container.scrollHeight;
          });
        },
        //检查是否进入留言界面
        doCheck:function(){
          let param={
            token:this.token,
            companyCode:this.companyCode,
            empListStr:""
          };
          let that = this;
          this.$http.post("api/chatApi/doCheckInOrOut.json",param).then(function (res) {  //消息查询
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let data = res.data.obj.chatMsg;
            if("0" === data){
              that.$router.push({
                path: '/SubmitMessPage', query: {
                sessionChannel:"-7",
                companyCode:that.companyCode
                }
              });
              return false;
            }
            that.isOpen = true;
            if(!that.openId){
              that.initConfig();
            }else{
              that.sessionId = '';
              that.MQTT_SERVICE = 'wss://'+that.mqAddr+':15675/ws';
              that.connect();
            }
          })
        },
        initConfig:function () {
          let param={
            token:this.token,
            companyCode:this.companyCode,
            browseUrl:this.browseUrl,
            navId:this.navId,
            openId:this.openId,
          };
          let that = this;
          this.$http.post("api/chatApi/getChatH5Config.json",param).then(function (res) {  //消息查询
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let data = res.data.obj;
            that.mqAddr = data.mqAddr;
            that.MQTT_SERVICE = 'ws://'+data.mqAddr+':15674/ws';

            if (that.urlIp.indexOf("https") != "-1") {
              that.MQTT_SERVICE = 'wss://'+that.mqAddr+':15675/ws';
            }
            if(!data.WxName){
              this.$Message.error("您的链接已失效，请使用配置中的最新链接。");
              return false;
            }
            that.sessionId = '';
            that.sessionStatus = '0';
            that.openId = data.openId;
            that.wxName = data.WxName;
            that.currentCustomer = data.openId;
            that.value = data.visitorName;
            that.topic = data.unionId;
            that.channelName = data.channelName;
            that.connect();
          })
        },
        //判断是否为ios
        isIos:function () {
          let UA = navigator.userAgent;
          if (UA.match(/iPad/) || UA.match(/iPhone/) || UA.match(/iPod/)) {
            return true;
          }else{
            return false;
          }
        },
      },
      destroyed() {
        window.removeEventListener('beforeunload', e => this.request)
      },
      mounted() {
        window.addEventListener('beforeunload', this.request);
        this.$once('hook:beoforeDestroy', this.request);
      },
      created() {
        this.openFlag = true;
        let keyboardRetraction;
        if (this.isIos()) {
          document.body.addEventListener('focusin', () => { // 软键盘弹起事件
            clearTimeout(keyboardRetraction);
          })
          document.body.addEventListener('focusout', () => { // 软键盘关闭事件
            clearTimeout(keyboardRetraction);
            keyboardRetraction = setTimeout(function() {
              // 当键盘收起的时候让页面回到原始位置
              window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            }, 200)
          })
        }
        //外部url代入的参数
        this.token = this.$route.query.token;
        this.companyCode = this.$route.query.companyCode;
        this.browseUrl = this.$route.query.browseUrl;
        this.navId = this.$route.query.navId;
        this.isNewOpen = this.$route.query.isNewOpen;
        if(!this.token){
          this.token = "";
        }
        if(!this.companyCode){
          this.companyCode = "";
        }
        if(!this.browseUrl){
          this.browseUrl = "";
        }
        if(!this.navId){
          this.navId = "";
        }
        if(!this.isNewOpen){
          this.isNewOpen = "";
        }
        this.screenHeight.height="86%";
        //判断是否是从嵌入js过来，此时将头部状态栏隐藏
        if(this.browseUrl || this.navId){
          if("2" === this.isNewOpen){
            this.openFlag = false;
            this.screenHeight.height="92%";
            this.isOpen = true;
            this.initConfig();
            return;
          }
          this.initConfig();
        }else{
          //检查是否进入留言还是聊天界面
          this.doCheck();
        }
        let port = window.location.port;
        let ip = window.location.host;
        let httpStyle = window.location.protocol;
        if(httpStyle.indexOf(':') < 0){
          httpStyle = httpStyle + ":";
        }
        if(port !== undefined && port !== ""){
          ip = ip + ":" + port;
        }
        this.urlIp = httpStyle + '//' + ip + '/mpccApi/';
      },
      watch: {

        // 监听中间显示对话数据，滑动到最下面
        onLineMsgList(){
          this.scrollToBottom();
        },
      }
    }

</script>

<style scoped>
  body {
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
  }
  .rowOne{
    width: 100%;
    background-color: rgb(242,243,245);
  }
  .cusandstaff{
    margin: 10px 5px 0px 5px;
    font-size: 14px;
  }
  .online_cus{
    margin:10px 5px 0px 5px;
    display: flex;
  }
  .online_cus_infoimg{
    width:38px;margin-right:10px;margin-top:5px;
  }
  img{
    width:30px;
  }
  .online_cus_infodetail{
    display: flex;
    align-items:center;
  }
  .online_cus_info{
    color:#e49149;
  }
  .online_cus_dialofont{
    color:#5c5c5b;
    white-space: pre-wrap;
    letter-spacing:2px;
    width:100%;
  }
  .online_staff{
    margin:10px 15px 0px 5px;
    overflow: hidden;
  }
  .online_staff_infodetail{
    float:right;
    display: flex;
    align-items:center;
  }
  .online_staff_info{
    overflow:hidden;
    display: inline;
    color:#1d82fe;
  }
  .online_staff_dialofont{
    float:right;
    width:100%;
    color:#5c5c5b;
    font-size: 14px;
    text-align: right;
    letter-spacing:2px;
    white-space: pre-wrap;
    padding-left: 10%;
  }
  .inputbox-iconlist{
    display:flex;
    justify-content:flex-start;
  }
  .inputbox-button{
    width: 20px;
    height:20px;
    margin-right:20px;
  }
  img{
    width:20px;
  }
  .inputbox-iconlist{
    display:flex;
    justify-content:flex-start;
  }
  .inputbox-button{
    width: 20px;
    height: 20px;
    margin-right: 6px;
    line-height: 1;
  }
  .edittext:empty::before{
    color:lightgrey;
    content:attr(placeholder);
  }
  .edittext {
    overflow-y: auto;
    font-size: 18px;
  }
  ::-webkit-scrollbar {/*滚动条整体样式*/
    width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #ccc;
  }
  ::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #EDEDED;
  }
  .msgTipDiv{
    text-align: center;
    color: #666;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OnlineService/ExternalWebPage.vue